import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import Pagination from "../components/Pagination.jsx";
import "../styles/pages/stations_page.css";
import ChevronRightIcon from "../assets/icons/chevron-right.svg";
import MapStationIcon from "../assets/icons/map-station-icon.svg";
import SearchIcon from "../assets/icons/search-icon.svg";
import Loader from "../components/Loader.jsx";
import ErrorPage from "../pages/ErrorPage.jsx";
import { fetchStations } from "../services/apiService";

const StationsMapPage = () => {
  const [stations, setStations] = useState([]);
  const [filteredStations, setFilteredStations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMapInitialized, setIsMapInitialized] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [searchText, setSearchText] = useState("");
  const [activeFilters, setActiveFilters] = useState({
    store: false,
    lpg: false,
    bpower: false,
    "100": false,
    ai95: false,
    ai92: false,
    dt: false,
    frenchDog: false,
    coffee: false,
    bakery: false,
    coffee_zone: false,
    terminal: false,
    atm: false,
    bicycleCorner: false,
    plasticDispose: false,
    batteryDispose: false,
    bookTrade: false,
    takeClothes: false,
    vulcanization: false,
    toilet: false,
    placeForPraying: false,
    condomate: false,
    socGs: false,
    kfcAuto: false,
    freeWifi: false,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const stationsPerPage = 10;

  useEffect(() => {
    const loadStations = async () => {
      setIsLoading(true);
      try {
        const data = await fetchStations();
        setStations(data);
        setFilteredStations(data);
      } catch (err) {
        console.error(err);
        setError("Ошибка загрузки данных");
      } finally {
        setIsLoading(false);
      }
    };
    loadStations();
  }, []);

  const applyFilters = (text, filters) => {
    let filtered = stations;
    if (text.trim() !== "") {
      const lowText = text.toLowerCase();
      filtered = filtered.filter(
        (station) =>
          station.gs_serial.toLowerCase().includes(lowText) ||
          station.city.toLowerCase().includes(lowText) ||
          station.address.toLowerCase().includes(lowText)
      );
    }
    const anyFilterActive = Object.values(filters).some((v) => v);
    if (anyFilterActive) {
      filtered = filtered.filter((station) => {
        if (filters.store && station.is_store_available !== true) return false;
        if (filters.lpg && station.is_lpg_available !== true) return false;
        if (filters.bpower && station.is_bpower_available !== true) return false;
        if (filters["100"] && station.is_100_available !== true) return false;
        if (filters.ai95 && station.is_ai95_available !== true) return false;
        if (filters.ai92 && station.is_ai92_available !== true) return false;
        if (filters.dt && station.is_dt_available !== true) return false;
        if (filters.frenchDog && (!station.gasStationService || station.gasStationService.frenchDog !== true))
          return false;
        if (filters.coffee && (!station.gasStationService || station.gasStationService.coffee !== true))
          return false;
        if (filters.bakery && (!station.gasStationService || station.gasStationService.bakery !== true))
          return false;
        if (filters.coffee_zone && (!station.gasStationService || station.gasStationService.coffee_zone !== true))
          return false;
        if (filters.terminal && (!station.gasStationService || station.gasStationService.terminal !== true))
          return false;
        if (filters.atm && (!station.gasStationService || station.gasStationService.atm !== true))
          return false;
        if (filters.bicycleCorner && (!station.gasStationService || station.gasStationService.bicycleCorner !== true))
          return false;
        if (filters.plasticDispose && (!station.gasStationService || station.gasStationService.plasticDispose !== true))
          return false;
        if (filters.batteryDispose && (!station.gasStationService || station.gasStationService.batteryDispose !== true))
          return false;
        if (filters.bookTrade && (!station.gasStationService || station.gasStationService.bookTrade !== true))
          return false;
        if (filters.takeClothes && (!station.gasStationService || station.gasStationService.takeClothes !== true))
          return false;
        if (filters.vulcanization && (!station.gasStationService || station.gasStationService.vulcanization !== true))
          return false;
        if (filters.toilet && (!station.gasStationService || station.gasStationService.toilet !== true))
          return false;
        if (filters.placeForPraying && (!station.gasStationService || station.gasStationService.placeForPraying !== true))
          return false;
        if (filters.condomate && (!station.gasStationService || station.gasStationService.condomate !== true))
          return false;
        if (filters.socGs && (!station.gasStationService || station.gasStationService.socGs !== true))
          return false;
        if (filters.kfcAuto && (!station.gasStationService || station.gasStationService.kfcAuto !== true))
          return false;
        if (filters.freeWifi && (!station.gasStationService || station.gasStationService.freeWifi !== true))
          return false;
        return true;
      });
    }
    setFilteredStations(filtered);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    const resetFilters = {
      store: false,
      lpg: false,
      bpower: false,
      "100": false,
      ai95: false,
      ai92: false,
      dt: false,
      frenchDog: false,
      coffee: false,
      bakery: false,
      coffee_zone: false,
      terminal: false,
      atm: false,
      bicycleCorner: false,
      plasticDispose: false,
      batteryDispose: false,
      bookTrade: false,
      takeClothes: false,
      vulcanization: false,
      toilet: false,
      placeForPraying: false,
      condomate: false,
      socGs: false,
      kfcAuto: false,
      freeWifi: false,
    };
    setActiveFilters(resetFilters);
    setSearchText("");
    setSearchInput("");
    setFilteredStations(stations);
    setCurrentPage(1);
  };

  const toggleFilter = (filterType) => {
    const updated = { ...activeFilters, [filterType]: !activeFilters[filterType] };
    setActiveFilters(updated);
    applyFilters(searchText, updated);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);
    if (value.trim() === "") {
      setSearchText("");
      setFilteredStations(stations);
      setCurrentPage(1);
    }
  };

  const handleSearchClick = () => {
    setSearchText(searchInput);
    applyFilters(searchInput, activeFilters);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearchClick();
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastStation = currentPage * stationsPerPage;
  const indexOfFirstStation = indexOfLastStation - stationsPerPage;
  const currentStations = filteredStations.slice(indexOfFirstStation, indexOfLastStation);
  const totalPages = Math.ceil(filteredStations.length / stationsPerPage);

  const mapRef = useRef(null);
  const updateMapMarkers = useCallback(() => {
    if (mapRef.current && window.ymaps && filteredStations.length > 0) {
      mapRef.current.geoObjects.removeAll();
      const collection = new window.ymaps.GeoObjectCollection();
      filteredStations.forEach((station) => {
        const placemark = new window.ymaps.Placemark(
          [station.latitude, station.longitude],
          {
            balloonContent: `<strong>${station.gs_serial}</strong><br/>${station.address}`,
          },
          {
            iconLayout: "default#image",
            iconImageHref: MapStationIcon,
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42],
          }
        );
        collection.add(placemark);
      });
      mapRef.current.geoObjects.add(collection);
      const bounds = collection.getBounds();
      if (bounds) {
        mapRef.current.setBounds(bounds, {
          checkZoomRange: true,
          zoomMargin: 50,
        });
      }
    } else if (mapRef.current && window.ymaps) {
      mapRef.current.setCenter([42.87, 74.6], 12);
    }
  }, [filteredStations]);

  const initMap = useCallback(() => {
    const mapContainer = document.getElementById("map");
    if (!mapContainer || !window.ymaps || stations.length === 0) return;

    const initialCenter = [stations[0].latitude, stations[0].longitude];

    if (mapRef.current) {
      mapRef.current.destroy();
    }

    mapRef.current = new window.ymaps.Map(mapContainer, {
      center: initialCenter,
      zoom: 12,
      controls: ["zoomControl", "geolocationControl"],
    });

    updateMapMarkers();
    setIsMapInitialized(true);
  }, [stations, updateMapMarkers]);


  useEffect(() => {
    if (!isLoading && stations.length > 0) {
      if (!window.ymaps) {
        const script = document.createElement("script");
        script.src =
          "https://api-maps.yandex.ru/2.1/?apikey=5746f9e1-3ad4-44b2-9b97-25abc3550550&lang=ru_RU";
        script.async = true;
        script.onload = () => window.ymaps.ready(initMap);
        script.onerror = (err) => console.error("Ошибка загрузки Yandex Maps:", err);
        document.body.appendChild(script);

        return () => script.remove();
      } else {
        window.ymaps.ready(initMap);
      }
    }
  }, [isLoading, stations, initMap]);


  useEffect(() => {
    if (mapRef.current && window.ymaps && isMapInitialized) {
      updateMapMarkers();
    }
  }, [filteredStations, updateMapMarkers, isMapInitialized]);

  useEffect(() => {
    if (isMapInitialized && filteredStations.length > 0) {
      updateMapMarkers();
    }
  }, [filteredStations, isMapInitialized, updateMapMarkers]);

  if (error) return <ErrorPage />;
  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="stations-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">Главная</a>
        <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
        <span className="nav-link">Карта АЗС</span>
      </nav>
      <div className="stations-page-content">
        <div id="map" className="stations-map-section"></div>
        <div className="stations-table-section">
          <h3 className="stations-map-title">
            На данной карте Вы сможете найти ближайшую к Вам АЗС нашей сети.
          </h3>
          <div className="search-container">
            <div className="input-wrapper">
              <img src={SearchIcon} alt="Search icon" className="map-search-icon" />
              <input
                type="text"
                className="stations-search"
                placeholder="Введите адрес для поиска ближайшего АЗС"
                onChange={handleSearchInputChange}
                onKeyDown={handleKeyDown}
                value={searchInput}
              />
            </div>
            <button className="search-button" onClick={handleSearchClick}>
              Найти
            </button>
          </div>
          <div className="filter-buttons">
            <button
              onClick={clearFilters}
              className={`filter-button ${Object.values(activeFilters).every((v) => !v) && searchText === ""
                ? "active"
                : ""
                }`}
            >
              Все
            </button>
            <button
              onClick={() => toggleFilter("store")}
              className={`filter-button ${activeFilters.store ? "active" : ""}`}
            >
              Магазин
            </button>
            <button
              onClick={() => toggleFilter("100")}
              className={`filter-button ${activeFilters["100"] ? "active" : ""}`}
            >
              АИ-100
            </button>
            <button
              onClick={() => toggleFilter("ai95")}
              className={`filter-button ${activeFilters.ai95 ? "active" : ""}`}
            >
              АИ-95
            </button>
            {stations.some(s => s.is_ai92_available) && (
              <button
                onClick={() => toggleFilter("ai92")}
                className={`filter-button ${activeFilters.ai92 ? "active" : ""}`}
              >
                АИ-92
              </button>
            )}
            <button
              onClick={() => toggleFilter("bpower")}
              className={`filter-button ${activeFilters.bpower ? "active" : ""}`}
            >
              B-power
            </button>
            <button
              onClick={() => toggleFilter("dt")}
              className={`filter-button ${activeFilters.dt ? "active" : ""}`}
            >
              ДТ
            </button>
            <button
              onClick={() => toggleFilter("lpg")}
              className={`filter-button ${activeFilters.lpg ? "active" : ""}`}
            >
              Газ
            </button>
            <button
              onClick={() => toggleFilter("frenchDog")}
              className={`filter-button ${activeFilters.frenchDog ? "active" : ""}`}
            >
              Френч-дог
            </button>
            <button
              onClick={() => toggleFilter("coffee")}
              className={`filter-button ${activeFilters.coffee ? "active" : ""}`}
            >
              Кофе
            </button>
            <button
              onClick={() => toggleFilter("bakery")}
              className={`filter-button ${activeFilters.bakery ? "active" : ""}`}
            >
              Выпечка
            </button>
            <button
              onClick={() => toggleFilter("coffee_zone")}
              className={`filter-button ${activeFilters.coffee_zone ? "active" : ""}`}
            >
              Кофейная зона
            </button>
            <button
              onClick={() => toggleFilter("terminal")}
              className={`filter-button ${activeFilters.terminal ? "active" : ""}`}
            >
              Терминал
            </button>
            <button
              onClick={() => toggleFilter("atm")}
              className={`filter-button ${activeFilters.atm ? "active" : ""}`}
            >
              Банкомат
            </button>
            <button
              onClick={() => toggleFilter("bicycleCorner")}
              className={`filter-button ${activeFilters.bicycleCorner ? "active" : ""}`}
            >
              Велокорнер
            </button>
            <button
              onClick={() => toggleFilter("plasticDispose")}
              className={`filter-button ${activeFilters.plasticDispose ? "active" : ""}`}
            >
              Сбор пластика
            </button>
            <button
              onClick={() => toggleFilter("batteryDispose")}
              className={`filter-button ${activeFilters.batteryDispose ? "active" : ""}`}
            >
              Сбор батареек
            </button>
            <button
              onClick={() => toggleFilter("bookTrade")}
              className={`filter-button ${activeFilters.bookTrade ? "active" : ""}`}
            >
              Обмен книг
            </button>
            <button
              onClick={() => toggleFilter("takeClothes")}
              className={`filter-button ${activeFilters.takeClothes ? "active" : ""}`}
            >
              Прием одежды
            </button>
            <button
              onClick={() => toggleFilter("vulcanization")}
              className={`filter-button ${activeFilters.vulcanization ? "active" : ""}`}
            >
              Вулканизация
            </button>
            <button
              onClick={() => toggleFilter("toilet")}
              className={`filter-button ${activeFilters.toilet ? "active" : ""}`}
            >
              Туалет
            </button>
            <button
              onClick={() => toggleFilter("placeForPraying")}
              className={`filter-button ${activeFilters.placeForPraying ? "active" : ""}`}
            >
              Намазкана
            </button>
            <button
              onClick={() => toggleFilter("condomate")}
              className={`filter-button ${activeFilters.condomate ? "active" : ""}`}
            >
              Кондомат
            </button>
            <button
              onClick={() => toggleFilter("kfcAuto")}
              className={`filter-button ${activeFilters.kfcAuto ? "active" : ""}`}
            >
              KFC Auto
            </button>
            <button
              onClick={() => toggleFilter("freeWifi")}
              className={`filter-button ${activeFilters.freeWifi ? "active" : ""}`}
            >
              Бесплатный WiFi
            </button>
          </div>
          <div className="stations-table-container">
            <table className="table">
              <colgroup className="table-colgroup">
                <col className="table-col" style={{ width: "25%" }} />
                <col className="table-col spacer-col" />
                <col className="table-col" style={{ width: "25%" }} />
                <col className="table-col spacer-col" />
                <col className="table-col" style={{ width: "50%" }} />
              </colgroup>
              <thead className="table-thead">
                <tr className="table-header-row">
                  <th className="table-header">АЗС</th>
                  <th className="table-header spacer"></th>
                  <th className="table-header">Город</th>
                  <th className="table-header spacer"></th>
                  <th className="table-header">Адрес</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {currentStations.length > 0 ? (
                  currentStations.map((station) => (
                    <tr key={station.id} className="table-row">
                      <td className="table-cell">{station.gs_serial}</td>
                      <td className="table-cell spacer"></td>
                      <td className="table-cell">{station.city}</td>
                      <td className="table-cell spacer"></td>
                      <td className="table-cell">{station.address}</td>
                    </tr>
                  ))
                ) : (
                  <tr className="table-row">
                    <td colSpan="5" className="table-cell no-data">
                      АЗС не найдена
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      <Footer />
    </div>
  );
};

export default StationsMapPage;